<!-- 库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.add" @click="showAddAPDialog()">{{
                    permission.add
                }}</el-button>
                <el-button size="small" type="warning" class="search-btn" v-if="permission.batchAddShopRs" @click="addShopRsDialog()">{{
                    permission.batchAddShopRs
                }}</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.exportImg"
                    @click="downGoodsImg()">{{ permission.exportImg }}</el-button>
            </div>
        </div>
        <div class="table-ctn goodlist-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @cell-dblclick="handleDBClick"
                @sort-change="sortChange"
                :tableCode="tableCode"
                empty-text="暂无相关库存商品信息"
                v-loading="loading"
                ref="multipleTable"
            >
                <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'APCode'"
                        show-overflow-tooltip
                        fixed="left"
                    >
                        <template slot="header">
                            {{ col.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.MainImg" icon="el-icon-picture" type="text" @click="getGoodsImages(scope.row.GoodsId)"></el-button>
                            {{ scope.row.APCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'AutoSerise'"
                    >
                        <template slot="header">
                            {{ col.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            <el-tag
                                @click="showSeries(scope.row)"
                                v-if="scope.row.SeriesCount > 0 || scope.row.IsCommonSeries"
                                type="danger"
                                effect="plain"
                                size="small"
                                style="padding: 0 2px"
                                >{{ scope.row.IsCommonSeries ? '通用' : scope.row.SeriesCount }}</el-tag
                            >
                            {{ scope.row.AutoSerise }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'CompletionRate'"
                    >
                        <template slot="header">
                            {{ col.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.CompletionRate }}%
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'IsCheck'"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.IsCheck ? '审核通过' : '未过审' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'RsShopName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.LoadShopRs" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ scope.row.RsShopName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :isCanSet="true" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="showAddAPDialog(scope.row)" v-if="permission.edit && !scope.row.IsCheck">{{ permission.edit }}</el-button>
                            <el-button type="text" size="mini" @click="addShopRsDialog(scope.row,0)" style="color: #FF9900" v-if="permission.addShopRs">{{ permission.addShopRs }}</el-button>
                            <el-button type="text" size="mini" @click="delGoods(scope.row)" style="color: red" v-if="permission.del">{{
                                permission.del
                            }}</el-button>
                            <el-button type="text" size="mini" @click="setCheckState(scope.row)" style="color: #FF9900" v-if="permission.check && !scope.row.IsCheck">{{ permission.check }}</el-button>
                            <el-button type="text" size="mini" @click="setCheckState(scope.row)" style="color: red" v-if="permission.unCheck && scope.row.IsCheck">{{ permission.unCheck }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="库存商品搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-goods-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item :label="searchShowSets.JointSearch.Title" v-if="searchShowSets.JointSearch.IsShow">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            size="small"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.APCode.Title" v-if="searchShowSets.APCode.IsShow">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            :placeholder="searchShowSets.APCode.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAPCodeLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.GoodName.Title" v-if="searchShowSets.GoodName.IsShow">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            :placeholder="searchShowSets.GoodName.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.AutoSerise.Title" v-if="searchShowSets.AutoSerise.IsShow">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            :placeholder="searchShowSets.AutoSerise.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.BrandId.Title" v-if="searchShowSets.BrandId.IsShow">
                        <el-select
                            ref="search_4"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Cate.Title" v-if="searchShowSets.Cate.IsShow">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Size.Title" v-if="searchShowSets.Size.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_6')"
                            ref="search_6"
                            class="search-item"
                            size="small"
                            v-model="searchData.Size"
                            :placeholder="searchShowSets.Size.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="英文车型" v-if="searchShowSets.ExAttribute6.IsShow">
                       <el-input
                            @focus="selectAutoHandle('search_7')"
                            ref="search_7"
                            class="search-item"
                            size="small"
                            v-model="searchData.ExAttribute6"
                            placeholder="请输入英文车型"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.IsCheck.Title" v-if="searchShowSets.IsCheck.IsShow">
                        <el-select
                            ref="search_8"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.IsCheck"
                            filterable
                            clearable
                        >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="已审核" value="1"></el-option>
                            <el-option label="未审核" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Texture.Title" v-if="searchShowSets.Texture.IsShow">
                        <el-input
                            ref="search_9"
                            class="search-item"
                            size="small"
                            v-model="searchData.Texture"
                            placeholder="请输入材质"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary" v-if="permission.advancedSearch" @click="searchSets">{{
                        permission.advancedSearch
                    }}</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg_ec :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg_ec>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets :tableCode="tableCode" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false" 
            title="商品加入店铺" 
            :visible.sync="dialogShopRsVisible" 
            width="600px"
            id="shop-goods-dialog"
            custom-class="shop-item-dialog">
            <div class="dialog-content" v-if="dialogShopRsVisible">
                <div v-loading="loading">
                    <div class="form-main">
                        <el-form :model="addShopRs" :rules="rules1" ref="addShopRs" label-width="80px"
                            class="formData">
                            <div v-if="addShopRs.GoodsIds.length > 0">当前已勾选{{ addShopRs.GoodsIds.length }}个商品</div>
                            <div class="formData-top">
                                <div class="form-left form-column">
                                    <el-form-item label="电商平台">
                                        <el-select v-model="addShopRs.PlatformId" @change="platformChange" placeholder="请选择电商平台">
                                            <el-option v-for="item in platformList" :key="item.Id"
                                                :label="item.Name" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="店铺" prop="Shop">
                                        <el-select v-model="addShopRs.ShopIds"
                                            multiple
                                            filterable
                                            clearable
                                            collapse-tags 
                                            placeholder="请选择店铺"
                                        >
                                            <el-option v-for="item in shopsList" :key="item.Id"
                                                :label="item.ShopName" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                        <div class="dialog-footer">
                            <el-button @click="cancelShop()">取消</el-button>
                            <el-button class="btn-primary" v-if="addShopRs.GoodsId" @click="setShopRsStaff()">提交</el-button>
                            <el-button class="btn-primary" v-else @click="batchSetShopRsStaff()">提交</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import APMsg_ec from '@/components/business/ecPlatform/apMsg_ec';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import searchSets from '@/components/common/searchSets.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg_ec,
        breadcrumb,
        elTableColumn,
        searchSets,
        ElImageViewer,
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) {
                        this.$refs.search_0.focus();
                        this.searchIndex = 0;
                    }
                });
            }
        },
    },
    data() {
        return {
            datetime1: [],
            datetime2: [],
            seriesVisible: false,
            tableCode: 'EC-GoodsTable',
            loading: false,
            optionLoading: false,
            isStopReq: false,
            isStopChildReq: false,
            isStartSearch: false,
            searchIndex: 0,
            goodsMsg: {},
            multipleSelection: [],
            goodsId: '',
            brand: [],
            choosedGood: {},
            typeList1: [],
            addAPVisible: false, //新增
            APMsgVisible: false, //编辑
            downloadUrl: this.$util.QN_URL_BASE,
            searchData: {
                JointSearch: '',
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                Texture:'',
                IsCheck: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: 15,
                SearchType: 2,
            },
            dialogTitle: '新增汽配', //dialog标题
            dialogVisible: false,
            searchSetVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            columnShowSets: [],
            isShowPerf: false,
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                SpaceType: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                BrandId: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                GoodDesc: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Texture: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                ExAttribute6: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                IsCheck: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                RsShopName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                }
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            separator: '',
            goodNameOptions: [],
            autoSeriseOptions: [],
            canSearch: true,
            srcList: [],
            showViewer: false,
            isShowUpdate: false,
            perfSetList: [],
            projectList: [],
            isShowProject: false,
            percentage: 0, //进度
            saveLoading: false,
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isSpaceSet:false,
            dialogShopRsVisible:false,
            platformList:[],
            shopsList:[],
            shopsListCopy:[],//用于前端搜索
            addShopRs:{
                GoodsId:'',
                GoodsIds:[],
                ShopIds:[]
            },
            rules1: {
                Shop: [
                    {
                        required: true,
                        message: "该项必选",
                        trigger: "blur"
                    }
                ],
            },
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
        this.getSearchCrtSetsData();
        this.getJointSearchSets();
        this.getConfigByCodes();
    },
    mounted() {
        this.$util.getSysConfig('splbycfpc').then(res => {
            if (res.Result) {
                this.isSpaceSet = true;
                this.searchData.SpaceType = ['0', '1'];
            }
            this.getTableData();
        });

        this.permission = this.$util.getPermission('ecAutoPartsManage');
    },
    //activated() {
        //使用了keepalive每一次进入页面都会触发activated勾子

        // if (this.$store.state.needRefresh) {
        //     this.$store.commit('updateNeedRefresh', false);
        //     this.getTableData();
        // }
    //},
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['qyzdyspsx', 'hzxmxzset'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'qyzdyspsx':
                                    this.isShowPerf = result;
                                    break;
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //按下一页、上一页、重新查询的时候，停下子接口的查询
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                //批量修改时取消回车事件
                if (!that.isShowUpdate && !that.dialogShopRsVisible) {
                    e.preventDefault();
                    if (
                        (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                        (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                        (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                        (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                        (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                        (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                        that.canSearch
                    ) {
                        that.handleSearch();
                    }
                    that.canSearch = true;
                    that.isStartSearch = false;
                }
            }
            //ESC
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                if (
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible)
                ) {
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.dialogVisible || that.dialogShopRsVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                    that.dialogShopRsVisible = false;
                }
            }
            //右键
            if (key === 39) {
                if (!this.dialogVisible && !that.showViewer && !that.dialogShopRsVisible) {
                    e.preventDefault();
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //左键
            if (key === 37) {
                if (!that.dialogVisible && !that.showViewer && !that.dialogShopRsVisible) {
                    e.preventDefault();
                    if (that.searchData.page !== 1) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 12) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 3 || that.searchIndex == 4) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.goodsId = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        showAddAPDialog(item) {
            if (item) {
                this.goodsId = item.GoodsId;
            } else {
                this.goodsId = '';
            }
            // 打开页面
            this.$router.push(`/ecPlatform/ecGoodsManage/addgoods?EntpTempGoodsId=${this.goodsId}`);
        },
        closeAddAPDialog(isEdit) {
            this.addAPVisible = false;
            if (isEdit) {
                this.getTableData();
            }
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .finally(() => {});
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                JointSearch: '',
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                Texture:'',
                GoodDesc: '',
                SpaceType: [],
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: 15,
                SearchType: 2
            };
            this.datetime1 = [];
            this.datetime2 = [];
            if(this.isSpaceSet){
                this.searchData.SpaceType = ['0', '1'];
            }
        },
        // 删除汽配
        delGoods(item) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除选中汽配吗?',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/DeleteEnterprisePart',
                            data: {
                                EntpTempGoodsId: item.GoodsId
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 设置审核状态
        setCheckState(item) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/SetEntpGoodsCheckState',
                    data: {
                        Id: item.GoodsId
                    }
                })
                .then(() => {
                    that.$util.successMsg('设置成功');
                    that.getTableData();
                })
                .catch(() => {});
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;

            if(event.order == null){
                this.searchData.SortProp = null;
            }

            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                
                this.loading = true;
                this.isStopReq = true;
                this.isStopChildReq = false;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetEnterprisePartList_ecVs',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        if (!data) {
                            this.tableData = [];
                            return;
                        }
                        let goodsIds = [];
                        for (let i = 0; i < data.length; i++) {
                            goodsIds.push(data[i].GoodsId);
                        }
                        this.tableData = data;
                        this.tableDataLength = res.count;
                        this.loadTableShopsData(goodsIds);
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        async loadTableShopsData(goodsIds) {
            let that = this;
            if (goodsIds && goodsIds.length > 0) {
                for (let i = 0; i < goodsIds.length; i++) {
                    if (!this.isStopChildReq) {
                        that.loopGetData(goodsIds[i]);
                        await that.$util.sleep(150);
                    } else return;
                }
            }
        },
        loopGetData(id) {
            let that = this;
            
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetGoodsShopRs',
                    data: { GoodsId: id},
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.GoodsId == data.GoodsId) {
                            item.LoadShopRs = false,
                            item.RsShopName = data.RsShopName;
                            item.RsShopIds = data.RsShopIds;
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.GoodsId) {
                this.showAPMsgDialog(event.GoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        searchSets() {
            if (this.tableCode) {
                this.searchSetVisible = true;
            }
        },
        closeDialog(isEdit) {
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData(this.tableCode, false).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'BrandId':
                            this.searchShowSets.BrandId.IsShow = item.IsShow;
                            this.searchShowSets.BrandId.Width = item.Width;
                            this.searchShowSets.BrandId.Placeholder = item.Placeholder;
                            this.searchShowSets.BrandId.Title = item.Title;
                            this.searchShowSets.BrandId.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'Texture':
                            this.searchShowSets.Texture.IsShow = item.IsShow;
                            this.searchShowSets.Texture.Width = item.Width;
                            this.searchShowSets.Texture.Placeholder = item.Placeholder;
                            this.searchShowSets.Texture.Title = item.Title;
                            this.searchShowSets.Texture.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                        case 'ExAttribute6':
                            this.searchShowSets.ExAttribute6.IsShow = item.IsShow;
                            this.searchShowSets.ExAttribute6.Width = item.Width;
                            this.searchShowSets.ExAttribute6.Placeholder = item.Placeholder;
                            this.searchShowSets.ExAttribute6.Title = item.Title;
                            this.searchShowSets.ExAttribute6.SortNum = item.SortNum;
                            break;
                        case 'IsCheck':
                            this.searchShowSets.IsCheck.IsShow = item.IsShow;
                            this.searchShowSets.IsCheck.Width = item.Width;
                            this.searchShowSets.IsCheck.Placeholder = item.Placeholder;
                            this.searchShowSets.IsCheck.Title = item.Title;
                            this.searchShowSets.IsCheck.SortNum = item.SortNum;
                            break;
                        case 'RsShopName':
                            this.searchShowSets.RsShopName.IsShow = item.IsShow;
                            this.searchShowSets.RsShopName.Width = item.Width;
                            this.searchShowSets.RsShopName.Placeholder = item.Placeholder;
                            this.searchShowSets.RsShopName.Title = item.Title;
                            this.searchShowSets.RsShopName.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
        },
        async getGoodsImages(goodsId) {
            this.srcList = [];
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsImages',
                data: { goodsId: goodsId }
            });
            if (data) {
                this.srcList = data;
            }
            this.showViewer = true;
        },
        mergeGoods() {
            this.$router.push(`/inventoryManage/goods/goodsMergeOrders`);
        },
        // 删除商品分类，品牌，单位缓存
        delEntpGoodsAttrCache(val) {
            this.$util.axiosPost({
                url: '/api/EntpGoods/DelEntpGoodsAttrCache?Keys=' + val,
                hideLoading: true
            });
        },
        //匹配单位
        searchUnit(queryString, cb) {
            if (this.unitList && this.unitList.length > 0) {
                let list = this.unitList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getConfigData(cb);
            }
        },
        //获取单位
        getConfigData(cb) {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
                if (cb) {
                    cb(this.unitList);
                }
            });
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        //获取品牌分类
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(res => {
                this.brandList = res;
                if (cb) {
                    cb(this.brandList);
                }
            });
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChangecar(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            }
        },
        showSeries(item) {
            if (item && item.GoodsId) {
                this.goodsId = item.GoodsId;
                this.seriesVisible = true;
            } else {
                this.goodsId = '';
                this.seriesVisible = false;
            }
        },
        perfVisibleChange() {
            let that = this;
            if (that.perfSetList.length == 0) {
                that.$util.getPerfSets().then(data => {
                    if (data) that.perfSetList = data;
                });
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        renderHeader(h, { column }) {
            return h('span', [
                h('span', column.label)
            ]);
        },
        addShopRsDialog(row){
            if(this.platformList.length == 0){
                this.getPlatformList();
            }
            
            if(this.shopsListCopy.length == 0){
                this.getShopsList();
            }else{
                this.shopsList = this.shopsListCopy;
            }

            if(row){
                // if(row.LoadShopRs){
                //     this.$util.warningMsg("请耐心等待店铺数据加载完成后，再进行操作！")
                //     return false;
                // }
                // this.addShopRs.ShopIds = row.RsShopIds;
                this.addShopRs.GoodsId = row.GoodsId;
            }else{
                if(this.multipleSelection.length == 0){
                    this.$util.warningMsg("请选择商品后再进行关联")
                    return false;
                }
                this.addShopRs.GoodsId = '';
                this.addShopRs.GoodsIds = this.multipleSelection.map(x=> x.GoodsId);
            }
            this.addShopRs.ShopIds = [];
            this.addShopRs.PlatformId = '';
            this.dialogShopRsVisible = true;
        },
        cancelShop(){
            this.addShopRs.PlatformId = "";
            this.dialogShopRsVisible = false;
        },
        downGoodsImg() {
            if(this.multipleSelection.length != 1){
                this.$util.warningMsg("只能选择一个商品数据！");
                return false;
            }
            this.loading = true;
            var goods = this.multipleSelection[0];
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/downGoodsImg',
                    data: { GoodsId: goods.GoodsId }
                })
                .then(res => {
                    if (res.errcode == 0) {

                        if(res.data.length == 0){
                            this.$util.warningMsg("该商品暂无图片！");
                            return false;
                        }

                        for (let i = 0; i < res.data.length; i++) {
                            const imgUrl = this.downloadUrl + res.data[i];
                            const fileName = goods.APCode + "(" + ( i + 1 ) +').png'; // 必须包含扩展名
                            this.downloadImage(imgUrl, fileName);
                        }
                        this.clearTableSelection();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        downloadImage(imageUrl, fileName) {
            const img = new Image();
            img.crossOrigin = 'anonymous';

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                canvas.toBlob(blob => {

                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    // 触发点击下载
                    a.click();
                    URL.revokeObjectURL(url);

                }, 'image/png');
            };

            img.onerror = () => {
                this.$util.errorMsg('图片下载失败，请检查链接是否有效');
            };
            img.src = imageUrl;
        },
        getPlatformList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetPlatformList?Type=1'
                })
                .then(res => {
                    if (res.data) {
                        this.platformList = res.data;
                    } else {
                        this.platformList = [];
                    }
                });
        },
        platformChange(val){
            var arr = this.shopsListCopy.filter(x=>x.PlatformId == val);
            if(arr)
                this.shopsList = arr;
            else
                this.shopsList = [];
        },
        getShopsList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetECShopsList'
                })
                .then(res => {
                    if (res.data) {
                        this.shopsList = res.data;
                        this.shopsListCopy = res.data;
                    } else {
                        this.shopsList = [];
                        this.shopsListCopy = [];
                    }
                });
        },
        setShopRsStaff(){
            if(this.addShopRs.ShopIds.length == 0){
                this.$util.warningMsg("请选择店铺后再提交！");
                return false;
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/SetEntpGoodsRsShop',
                    data: this.addShopRs
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg("设置成功");
                        this.dialogShopRsVisible = false;
                        this.getTableData();
                    }
                    this.loading = false;
                });
        },
        batchSetShopRsStaff(){
            if(this.addShopRs.ShopIds.length == 0){
                this.$util.warningMsg("请选择店铺后再提交！");
                return false;
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/BatchSetEntpGoodsRsShop',
                    data: this.addShopRs
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.dialogShopRsVisible = false;
                        this.getTableData();
                    }
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
#search-goods-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.form-main .dialog-footer {
    text-align: right;
}
.formData .el-select {
    width: 90%;
}
.formData-top{
    margin-top: 10px;
}
/deep/.el-table .cell {
    height: 23px !important;
    line-height: 23px !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}
</style>
<style lang="less">
.autocompleteInput .el-input input {
    width: 260px;
    height: 32px;
}
.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}
.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
.el-autocomplete-suggestion {
    width: 300px !important;
}

.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
</style>
